/* eslint-disable import/default */
import chiaBls from 'chia-bls';
import clvmLib, { Program as ProgramType } from 'clvm-lib';
/* eslint-enable import/default */
import type { SpendableCoin } from '~/stores/goby';
import { P2_CONDITIONS_MOD } from '~/utilities/puzzles';

/* eslint-disable import/no-named-as-default-member */
export const { hash256, concatBytes } = chiaBls;
export const { Program } = clvmLib;
/* eslint-enable import/no-named-as-default-member */

export const solutionForConditions = (conditions: ProgramType[]) => {
  const delegatedPuzzle = P2_CONDITIONS_MOD.run(Program.fromList([Program.fromList(conditions)])).value;
  return Program.fromList([Program.fromList([]), delegatedPuzzle, Program.fromInt(0)]);
};

export const CreateCoin = (puzzleHash: Uint8Array, amount: number, memos: Uint8Array[] = []) => {
  return Program.fromList([
    Program.fromInt(51),
    Program.fromBytes(puzzleHash),
    Program.fromInt(amount),
    Program.fromList(memos.map((memo) => Program.fromBytes(memo))),
  ]);
};

export const CreateCoinAnnouncement = (msg: Uint8Array) => {
  return Program.fromList([Program.fromInt(60), Program.fromBytes(msg)]);
};

export const AssertCoinAnnouncement = (coinId: Uint8Array, msg: Uint8Array) => {
  return Program.fromList([Program.fromInt(61), Program.fromBytes(hash256(concatBytes(coinId, msg)))]);
};

export const CreatePuzzleAnnouncement = (msg: Uint8Array) => {
  return Program.fromList([Program.fromInt(62), Program.fromBytes(msg)]);
};

export const AssertPuzzleAnnouncement = (puzzleHash: Uint8Array, msg: Uint8Array) => {
  return Program.fromList([Program.fromInt(63), Program.fromBytes(hash256(concatBytes(puzzleHash, msg)))]);
};

export const ReserveFeeCondition = (amount: number) => {
  return Program.fromList([Program.fromInt(52), Program.fromInt(amount)]);
};

export const trim0x = (hex: string) => (hex.startsWith('0x') ? hex.substring(2) : hex);

export function selectXchCoins(xchCoins: SpendableCoin[], totalValue: number) {
  const selectedCoins = [];
  let totalSelected = 0;

  const sortedCoins = xchCoins.sort((a, b) => b.coin.amount - a.coin.amount);
  for (const coin of sortedCoins) {
    selectedCoins.push(coin);
    totalSelected += coin.coin.amount;
    if (totalSelected >= totalValue) {
      break;
    }
  }

  if (totalSelected < totalValue) {
    throw new Error(`Balance not high enough to send transaction, available balance: ${totalSelected}`);
  }

  return {
    selectedCoins,
    changeAmount: totalSelected - totalValue,
  };
}

export function* asIter(program: ProgramType): IterableIterator<ProgramType> {
  let currentProgram = program;
  while (!currentProgram.isNull) {
    yield currentProgram.first;
    currentProgram = currentProgram.rest;
  }
}
